import api from 'utils/api';

export const REQUESTING_REFERRING_LOCATIONS = 'REQUESTING_REFERRING_LOCATIONS';
export const RECEIVE_REFERRING_LOCATIONS = 'RECEIVE_REFERRING_LOCATIONS';

function requestingReferringLocations() {
  return { type: REQUESTING_REFERRING_LOCATIONS };
}

function receiveReferringLocations(locations, receivedAt) {
  return { type: RECEIVE_REFERRING_LOCATIONS, referringLocations: locations, receivedAt };
}

const actions = {
  fetchReferringLocationsForProvider(dispatch, referringProviderEmploymentId) {
    dispatch(requestingReferringLocations());

    const path = '/agent_portal/api/referring_locations';
    const params = {
      referring_provider_employment_id: referringProviderEmploymentId,
    };
    return api.get(path, { params }).then(response => {
      dispatch(receiveReferringLocations(response.data, response.time));
      return response.data;
    });
  },
};

export default actions;
